<template>
  <div>
    <div class="restit">
      <div class="wp">
        <p v-if="reslist.length">
          <b>{{ key }}</b> {{$t('result.txt')}}
        </p>
      </div>
    </div>
    <div class="row-res">
      <div class="wp">
        <ul class="reslist" v-if="reslist.length">
          <li v-for="item of reslist" :key="item.id">
            <div class="con" @click="toDetail(item.id, item.style)">
              <h3>{{ item.contentTitle }}</h3>
              <div class="desc">{{ item.summary }}</div>
            </div>
          </li>
        </ul>
        <el-empty v-else :description="$t('recruit.desc')"></el-empty>
      </div>
    </div>

    <!-- <div class="pages" v-if="total && total>size">
            <ul>
                <li class="prev" :class="[(curPage == 1) ?'hide':'']">
                    <span @click="prevPage">&lt;</span>
                </li>
                <li
                    :class="[curPage == index + 1 ? 'on' : '']"
                    v-for="(item, index) of pages"
                    :key="index"
                >
                    <span @click="navToPage(index + 1)">{{ index + 1 }}</span>
                </li>
                <li class="next" :class="[(curPage==pages) ?'hide':'']">
                    <span @click="nextPage">&gt;</span>
                </li>
            </ul>
        </div> -->
  </div>
</template>

<script>
import { Loading } from 'element-ui';
export default {
  data () {
    return {
      key: '',
      reslist: [],
      style: '',

      /* pages: '',
      size: '',
      curPage: '',
      total: '', */
    }
  },
  created () {
    let that = this
    Loading.service();
    that.key = that.$route.params.keyword || that.$store.state.keyword
    if (that.key == '') {
      Loading.service().close();
      return;
    }
    that.getQuery(that.key)
  },

  computed: {
    mapboxMap1 () {
      return this.$store.state.keyword
    }
  },
  watch: {
    mapboxMap1 (newData, oldData) {
      this.key = newData
      this.getQuery(newData)
    }
  },

  methods: {
    toDetail (id, style) {
      let that = this
      that.$router.push({ name: 'Details', query: { id: id }, params: { style: style } })
    },
    getQuery (key) {
      let that = this;
      let data = {
        keywords: '*' + key + '*'
      };
      that.$http
        .getQuery(data)
        .then((res) => {
          if (res.code == 200) {
            Loading.service().close();
            that.reslist = res.result.records
            that.style = res.result.style
            /* that.pages = res.data.result.pages
            that.curPage = res.data.result.current
            that.total = res.data.result.total
            that.size = res.result.records.length */
          } else {
            Loading.service().close();
            that.reslist = []
          }
        })
    },
  }
}
</script>

<style>
</style>